<template>
    <div id="modal-message-box" @click.stop="onClose">
        <div class="modal-box">
            <div class="modal-header-box">
                <div class="modal-title-box">{{ title }}</div>
                <div
                    class="red-close ico ico-red-close"
                    v-if="isShowClose"
                    @click.stop="onClose"
                ></div>
            </div>

            <div class="modal-body-box">{{ body }}</div>

            <div class="modal-footer-box" v-if="hasBtn == 1">
                <div class="btnmid">
                    <div class="btn-c" @click.stop="onConfirm">
                        {{ confirmText }}
                    </div>
                </div>
            </div>
            <div class="modal-footer-box" v-if="hasBtn == 2">
                <div class="suc-btnLeft">
                    <div class="btn-l" @click.stop="onLeft">
                        {{ leftText }}
                    </div>
                </div>
                <div class="suc-btnRight">
                    <div class="btn-r" @click.stop="onRight">
                        {{ rightText }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Modal",
    props: {
        title: {
            type: String,
            default: "",
        },
        body: {
            type: [String],
            default: "",
        },
        hasBtn: {
            type: [Number],
            default: 1,
        },
        leftText: {
            type: String,
            default: "",
        },
        rightText: {
            type: String,
            default: "",
        },
        confirmText: {
            type: String,
            default: "",
        },
        isShowClose: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {
        onClose() {
            this.$emit("on-close");
        },
        onOK() {
            this.$emit("on-ok");
        },
        onLeft() {
            this.$emit("on-left");
        },
        onRight() {
            this.$emit("on-right");
        },
        onConfirm() {
            this.$emit("on-confirm");
        },
    },
};
</script>
<style>
#modal-message-box {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    z-index: 99999;
}
#modal-message-box .red-close {
    position: absolute;
    right: 20px;
    top: 20px;
}
#modal-message-box .modal-box {
    background: #141415;
    background-size: 715px 585px;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    width: 715px;
    height: 585px;
    text-align: center;
}

#modal-message-box .modal-header-box {
    height: 81px;
    color: #eee;
    justify-content: center;
    background: rgba(76, 75, 75, 0.4);
    display: flex;
    position: relative;
}

#modal-message-box .middleWarp {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 584px;
    height: 34px;
}

#modal-message-box .modal-header-bg {
    margin-top: 20px;
    height: 140px;
    width: 140px;
    color: #eee;
    justify-content: center;
    background: #fff;
    border-radius: 70px;
    display: flex;
    position: relative;
}

#modal-message-box .modal-title-box {
    margin-top: 30px;
    height: 43px;
    font-size: 36px;

    font-weight: bold;
    color: #d3d1d5;
    line-height: 30px;
    text-align: center;
}
#modal-message-box .modal-footer-box {
    justify-content: center;
    padding: 15px;
    display: flex;
}
#modal-message-box .modal-body-box {
    position: relative;
    margin-top: 60px;
    white-space: pre-line;
    height: 240px;
    padding: 30px 80px;
    word-wrap: break-word;
    font-size: 30px;
    color: #d3d1d5;
}

#modal-message-box .suc-btnLeft {
    flex: 1;
    height: 100%;
    width: 50%;
    display: flex;
    justify-content: center;
}
#modal-message-box .suc-btnRight {
    flex: 1;

    height: 100%;
    width: 50%;
    display: flex;
    justify-content: center;
}
.btn-c {
    color: #ffffff;
    width: 269px;
    height: 70px;
    background: #f74112;

    font-size: 36px;
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.35);
    border-radius: 35px;
    line-height: 70px;

    font-weight: bold;
}
.btn-r {
    color: #f82e49;
    width: 219px;
    height: 70px;
    background: rgba(247, 41, 41, 0);
    border: 3px solid #f82e49;
    border-radius: 15px;

    line-height: 70px;
    font-size: 36px;
    font-weight: bold;
}
.btn-l {
    color: #ffffff;
    width: 219px;
    height: 70px;
    background: #f82e49;
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.35);
    border-radius: 15px;
    font-weight: bold;
    line-height: 70px;
    font-size: 36px;
}
#modal-message-box .btnmid {
    margin: 0 auto;
    width: 100%;
    display: flex;
    justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/common/modal_message_box.vue